function checkAndAddDiv() {
  // Attempt to find the target div
  var targetDiv = document.querySelector(
    ".blog-page__title.widget__title.heading.h1"
  );

  // If the target div is found, add the new div after it
  if (targetDiv) {
    // Create the new div and set its content
    var newDiv = document.createElement("div");
    newDiv.innerHTML =
      '<a class="visit-blog" style="color: #95040b; text-decoration: underline;" href="/a/blog">Visit Our Blog</a>';

    newDiv.style.cssText = "float: right; margin-top: -100px; color:  #95040b;";

    // Insert the new div after the target div
    if (targetDiv.nextSibling) {
      targetDiv.parentNode.insertBefore(newDiv, targetDiv.nextSibling);
    } else {
      targetDiv.parentNode.appendChild(newDiv);
    }

    // Stop checking once the div is added
    clearInterval(intervalId);
  }
}

// Start an interval to check for the target div every 500 milliseconds
var intervalId = setInterval(checkAndAddDiv, 500);